import { useState } from 'react';
import config from '../../utils/apiUrl';

const useCreateUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);

  const createUser = async (userDetails) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${config.apiUrl}/users/payment/create/user`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userDetails),
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, ${errorText}`);
      }

      const data = await response.json();

      if (!data.success) {
        console.log(data);
        throw new Error(data.errorMessage || 'Error creando el usuario');
      }
      setUserData(data.user);
      localStorage.setItem(
        'nibi_app',
        JSON.stringify({ token: data.token, user: data.user })
      );

      return { success: true, userId: data.user._id };
    } catch (err) {
      console.error('Error creating user:', err);
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    createUser,
    loading,
    error,
    userData,
  };
};

export default useCreateUser;
